import { useCallback, useContext, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import pathObj from "../../services/Config";
import { CommonService } from "../../services/common";
import { checkImage, decryptData, errorHandling, UpdatedDecimalDigits } from "../../helpers/common";
import { formatPriceWithBreakdown } from "../../helpers/priceHelper";
import toast from "react-hot-toast";
// Add context to manage cart count across components
import { CartContext } from "../../context/cartContext";
import Pagination from 'react-js-pagination';
import ProductGrid from '../../components/ProductGrid/ProductGrid';
import { Helmet } from "react-helmet";
import debounce from "lodash.debounce";
import getSymbolFromCurrency from "currency-symbol-map";

const SearchResult = () => {
  const { addToCartCount, searchResultData, page, setPageList, searchResultProduct, setProductLimit, limit, setShortBy, shortBy,setFilters, selectedFilters  } = useContext(CartContext);
  const { text } = useParams();
  const [imageStatus, setImageStatus] = useState({});
  const [quantities, setQuantities] = useState({});
  const [priceDropdownVisible, setPriceDropdownVisible] = useState({});
  const [priceBreakDown, setPriceBreakDown] = useState('');
  const [priceBreak, setPriceBreak] = useState({});
  const [loading, setLoading] = useState(true);
  const [priceBreakDownloading, setPriceBreakDownLoading] = useState(false);
  const [productData, setProductData] = useState(searchResultData);
  // Cross-reference tab state
  const [crossRefData, setCrossRefData] = useState([]);
  const [crossRefPage, setCrossRefPage] = useState(1);
  const [crossRefTotal, setCrossRefTotal] = useState(0);
  const [crossRefLoading, setCrossRefLoading] = useState(false);
  // const [limit, setLimit] = useState(10);
  const [pageNo, setPageNo] = useState(page);
  const [listTotal, setListTotal] = useState(0);
  // const [shortBy, setNewShortBy] = useState('product_name');
  const [wishlistStatus, setWishlistStatus] = useState({});
  const [errorText, setErrorText] = useState('');
  const userInfo = window.localStorage.getItem('userData');
  const userD = decryptData(userInfo);
  const compData = JSON.parse(userD);
  const currencyName = compData?.Currency
  const currencySymbol = getSymbolFromCurrency(currencyName);
  const customerId = compData?.customer_id;
  const token = localStorage.getItem("Token");
  const navigate = useNavigate();
  const [attributesList, setAttributeList] = useState([]);
  // const [selectedFilters, setSelectedFilters] = useState([]);
  const payTermsGrp = compData?.PayTermsGrpCode;

  const [selectedPriceBreakdown, setSelectedPriceBreakdown] = useState({});
  const handleLimitChange = (event) => {
    const newLimit = parseInt(event.target.value);
    setProductLimit(newLimit);
    setPageNo(1);
    setPageList(1);
    fetchProductData(1, newLimit, shortBy, text);
  };

  const handleShortBy = (event) => {
    const selectedValue = event.target.value;
    setShortBy(selectedValue);
    setPageNo(1);
    setPageList(1);
    fetchProductData(1, limit, selectedValue, text);
  };


  const handlePageChange = (pageNumber) => {
    setPageNo(pageNumber)
    setPageList(pageNumber);
    fetchProductData(pageNumber, limit, shortBy, text);
  };
    
  const fetchProductData = async (pageNumber = 1, pageLimit = limit, short_by = shortBy, text) => {
    
    setLoading(true);
    try {
      const formattedFilters = selectedFilters;
      const Currency = compData?.Currency;
      const PriceListNum = compData?.PriceListNum;
      const customer_id = customerId;
     
      const pageList = pageNumber > 0 ? `page=${pageNumber}` : '';
      const pageLimits = pageLimit > 0 ? `limit=${pageLimit}` : '';
      const shorting = short_by ? `short_by=${short_by}` : '';
      const searchText = text;
      
      // Build query string properly
      const queryParams = [pageList, pageLimits, shorting].filter(Boolean).join('&');
      const queryString = queryParams ? `?${queryParams}` : '';
      
      const url = `${pathObj.baseURL}${pathObj.searchResult}${queryString}`;
      const payload = {
        search_text: searchText,
        Currency,
        PriceListNum,
        customer_id,
        filter_by: formattedFilters,
      };

      const data = await CommonService.getAllWithBody(url, payload);
      searchResultProduct(data?.data?.ProductList);
      setAttributeList(data?.data?.AttributesList);
      setListTotal(data?.data?.TotalProducts);
    } catch (error) {
      if (error?.response?.data?.success === false) {
        setErrorText(error?.response?.data?.message);
        setProductData([]);
        setListTotal(0);
      }
      // errorHandling(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setProductData(searchResultData)
    // Clear previous price breakdown data when new product data comes in
    setPriceBreak({});
  }, [searchResultData])

  const handleFilterChange = (filterLabel, filterValue, isChecked) => {
    setFilters((prevFilters) => {
      const existingFilter = prevFilters.find(filter => filter.filter_label === filterLabel);

      if (existingFilter) {
        // Convert the comma-separated string back to a Set
        const filterValuesSet = new Set(existingFilter.filter_label_data.split(','));

        if (isChecked) {
          filterValuesSet.add(filterValue); // Add new value when checked
        } else {
          filterValuesSet.delete(filterValue); // Remove value when unchecked
        }

        const updatedFilterData = [...filterValuesSet].join(',');

        if (updatedFilterData) {
          setPageNo(1)
          // If there are still values, update the filter
          return prevFilters?.map(filter =>
            filter.filter_label === filterLabel
              ? { ...filter, filter_label_data: updatedFilterData }
              : filter
          );
        } else {
          // If no values left, remove the entire filter entry
          return prevFilters.filter(filter => filter.filter_label !== filterLabel);
        }
      } else if (isChecked) {
        // If the filter doesn't exist and checkbox is checked, add a new entry
        return [...prevFilters, { filter_label: filterLabel, filter_label_data: filterValue }];
      }

      return prevFilters;
    });
  };

  const debouncedFetchProductData = debounce(fetchProductData, 300); // Adjust the delay as needed
  useEffect(() => {    
      debouncedFetchProductData(pageNo, limit, shortBy, text);
  }, [text, pageNo, limit, shortBy]);

  useEffect(() => {    
    if (selectedFilters?.length > 0) {
      setPageNo(1)
      debouncedFetchProductData(1, limit, shortBy, text);
    }else{
      debouncedFetchProductData(pageNo, limit, shortBy, text);
    }
  }, [selectedFilters]);


  // Generic image loader for any product list (used for main results and cross-ref)
  const loadImagesForList = useCallback(async (list) => {
    if (!list || list.length === 0) return;
    const status = {};

    const imagePromises = list.map(async (product) => {
      try {
        const pictureCheck = await checkImage(product?.Picture);
        const vectorPictureCheck = await checkImage(product?.vectorPicture);

        if (pictureCheck?.status === "ok") {
          status[product?.ItemCode] = pictureCheck?.path;
        } else if (vectorPictureCheck?.status === "ok") {
          status[product?.ItemCode] = vectorPictureCheck?.path;
        } else {
          status[product?.ItemCode] = `${pathObj?.s3ImagePath}/no-image.jpg`;
        }
      } catch (err) {
        status[product?.ItemCode] = `${pathObj?.s3ImagePath}/no-image.jpg`;
      }
    });

    await Promise.all(imagePromises);
    setImageStatus((prevStatus) => ({ ...prevStatus, ...status }));
  }, [pathObj?.s3ImagePath]);

  // Debounced wrapper to avoid rapid repeated calls
  const debouncedLoadImagesForList = useCallback(debounce((list) => {
    loadImagesForList(list);
  }, 300), [loadImagesForList]);

  useEffect(() => {
    if (productData?.length > 0) {
      debouncedLoadImagesForList(productData);
    }
  }, [productData, debouncedLoadImagesForList]);

  // Ensure cross-reference images also load when crossRefData arrives
  useEffect(() => {
    if (crossRefData?.length > 0) {
      debouncedLoadImagesForList(crossRefData);
    }
  }, [crossRefData, debouncedLoadImagesForList]);

  // Function to fetch price breakdowns for all products that have breakdown indicators
  const fetchAllProductBreakdowns = useCallback(async () => {
    if (!productData || productData.length === 0) return;
    
    const productsWithBreakdowns = productData.filter(product => 
      product?.GbpPriceBreakdown > 0 || product?.EuroPriceBreakdown > 0
    );

    if (productsWithBreakdowns.length === 0) return;

    try {
      // Use Promise.all to fetch all breakdowns simultaneously for faster loading
      const breakdownPromises = productsWithBreakdowns.map(async (product) => {
        try {
          const Currency = compData?.Currency;
          const PriceListNum = compData?.PriceListNum;
          const customer_id = customerId;
          const url = `${pathObj.baseURL}${pathObj.getProductPriceBreakdown}?ItemCode=${product.ItemCode}`;
          const payload = {
            Currency,
            PriceListNum,
            customer_id,
          };

          const data = await CommonService.getAllWithBodyWithToken(url, payload);
          const pricesBreakdown = data?.data?.PricesBreakdown;
          
          return { itemCode: product.ItemCode, breakdown: pricesBreakdown || [] };
        } catch (error) {
          console.error(`Error fetching price breakdown for ${product.ItemCode}:`, error);
          return { itemCode: product.ItemCode, breakdown: [] };
        }
      });

      const breakdownResults = await Promise.all(breakdownPromises);
      const newPriceBreak = {};
      breakdownResults.forEach(result => {
        newPriceBreak[result.itemCode] = result.breakdown;
      });
      
      setPriceBreak(newPriceBreak); // Set completely new object instead of merging
    } catch (error) {
      console.error('Error in fetchAllProductBreakdowns:', error);
    }
  }, [productData, compData?.Currency, compData?.PriceListNum, customerId]);

  const [currentPrice, setCurrentPrice] = useState(0); // Initialize with a default value
  const [priceBreakDownId, setPriceBreakDownId] = useState(0); // Initialize with a default value
  const [activeTab, setActiveTab] = useState('results');

  // Cross-reference: fetch only when user clicks the tab
  const fetchCrossRefData = async (pageNumber = 1, pageLimit = limit) => {
    setCrossRefLoading(true);
    try {
      const Currency = compData?.Currency;
      const PriceListNum = compData?.PriceListNum;
      const customer_id = customerId;

      const payload = {
        search_text: text,
        Currency,
        PriceListNum,
        customer_id,
        filter_by: selectedFilters,
        tab_type: 'cross_refrence'
      };

      const queryParams = [];
      if (pageNumber) queryParams.push(`page=${pageNumber}`);
      if (pageLimit) queryParams.push(`limit=${pageLimit}`);
      const queryString = queryParams.length ? `?${queryParams.join('&')}` : '';

      const url = `${pathObj.baseURL}${pathObj.searchResult}${queryString}`;
      const data = await CommonService.getAllWithBody(url, payload);

      setCrossRefData(data?.data?.ProductList || []);
      setCrossRefTotal(data?.data?.TotalProducts || 0);
      // Update attributes list for cross-reference results so sidebar reflects current results
      setAttributeList(data?.data?.AttributesList || []);
    } catch (error) {
      console.error('Error fetching cross reference data', error);
      setCrossRefData([]);
      setCrossRefTotal(0);
    } finally {
      setCrossRefLoading(false);
    }
  };

  const handleResultsTabClick = () => {
    setActiveTab('results');
    // Re-fetch main results to ensure attributesList reflects main results
    setPageNo(1);
    setPageList(1);
    fetchProductData(1, limit, shortBy, text);
  };

  const handleCrossRefTabClick = () => {
    setActiveTab('crossref');
    // Only fetch if not fetched before
    if (!crossRefData || crossRefData.length === 0) {
      setCrossRefPage(1);
      fetchCrossRefData(1, limit);
    }
  };

  const handleCrossRefPageChange = (pageNumber) => {
    setCrossRefPage(pageNumber);
    fetchCrossRefData(pageNumber, limit);
  };

  // If the cross-reference tab is active, refresh its data when relevant params change
  useEffect(() => {
    if (activeTab === 'crossref') {
      // keep crossRefPage but reset to 1 when search text or filters change
      fetchCrossRefData(crossRefPage, limit);
    }
  }, [activeTab, text, crossRefPage, limit, shortBy, selectedFilters]);

  // navigation helpers are implemented later in the file where routing and formatting are handled

  

  const handleQuantityChange = (itemCode, type, customQuantity = null) => {
    
    setQuantities((prevQuantities) => {
      const newQuantities = { ...prevQuantities };
      let currentQuantity = newQuantities[itemCode] || 1;
      currentQuantity = parseInt(currentQuantity);
      let newPriceBreakDownId = null; // Declare the variable here

      // If customQuantity is passed (from price breakdown), set it directly
      if (customQuantity !== null) {
        currentQuantity = parseInt(customQuantity);
      } else {
        if (type === "plus") {
          currentQuantity += 1;
          // Only call fetchProductPriceBreakdown if price dropdown is not visible yet
          if (!priceDropdownVisible[itemCode]) {
            debouncedFetchProductPriceBreakdown(itemCode); // Debounced API call
          }
        } else if (type === "minus" && currentQuantity > 1) {
          currentQuantity -= 1;
        }
      }

      // Update the quantity for the product
      newQuantities[itemCode] = currentQuantity;

      // New logic to update price based on quantity
      const priceBreaks = priceBreak[itemCode] || [];
      let newPrice = 0;
      for (let i = 0; i < priceBreaks?.length; i++) {
        if (currentQuantity >= priceBreaks[i].Quantity) {
          newPrice = priceBreaks[i].SpecialPrice;
          newPriceBreakDownId = priceBreaks[i].price_break_down_id;
        } else {
          break;
        }
      }

      // Update the state with the new price
      setCurrentPrice(newPrice); // Assuming you have a state to hold the current price
      setPriceBreakDownId(newPriceBreakDownId); // Assuming you have a state to hold the current price

      return newQuantities;
    });
  };

  const fetchProductPriceBreakdown = async (ItemCode) => {
    try {
      const Currency = compData?.Currency;
      const PriceListNum = compData?.PriceListNum;
      const customer_id = customerId;
      const url = `${pathObj.baseURL}${pathObj.getProductPriceBreakdown}?ItemCode=${ItemCode}`;
      const payload = {
        Currency,
        PriceListNum,
        customer_id,
      };

      const data = await CommonService.getAllWithBodyWithToken(url, payload);
      const pricesBreakdown = data?.data?.PricesBreakdown;
      
      // Show the price dropdown only if there's a valid price breakdown
      setPriceDropdownVisible((prevVisible) => ({
        ...prevVisible,
        [ItemCode]: pricesBreakdown?.length > 0, // Only show dropdown if breakdown exists
      }));

      // Update price breakdown data
      setPriceBreak((prevBreaks) => ({
        ...prevBreaks,
        [ItemCode]: pricesBreakdown || [],
      }));
    } catch (error) {
      console.error("Error fetching price breakdown:", error);
      // Ensure the dropdown is hidden if an error occurs
      setPriceDropdownVisible((prevVisible) => ({
        ...prevVisible,
        [ItemCode]: false,
      }));
      errorHandling(error);
    }
  };

  // New function to handle the toggle of priceDropdownVisible
  const togglePriceDropdown = (itemCode) => {
    // setPriceDropdownVisible((prevVisible) => ({
    //   ...prevVisible,
    //   [itemCode]: !prevVisible[itemCode],
    // }));
    setPriceBreakDownLoading(true)
    // Optionally, fetch the price breakdown if making it visible
    if (!priceDropdownVisible[itemCode]) {
      debouncedFetchProductPriceBreakdown(itemCode);
    }
    setPriceBreakDownLoading(false)
  };

  const debouncedFetchProductPriceBreakdown = debounce(fetchProductPriceBreakdown, 300);

  const handlePriceBreakdownClick = (itemCode, quantity, priceBreakDownId, price) => {
    setPriceBreakDown(priceBreakDownId)
    setSelectedPriceBreakdown((prevBreakdowns) => ({
      ...prevBreakdowns,
      [itemCode]: {
        quantity,
        price, // Use the passed price
        priceBreakDownId,
      },
    }));
    handleQuantityChange(itemCode, null, quantity);
  };

  const handleProductDetailsClick = (product) => {
    localStorage.setItem('productType', product?.ProductType);
    const formattedItemCode = product?.ItemCode.replace(/\//g, '__'); // Replace slashes with hyphens
    navigate(`/products/${formattedItemCode}`);
  };

  const handleAddToCart = async (product) => {
    if (product?.QuantityOnStock > 0 || (product?.QuantityOnStock <= 0 && payTermsGrp != 17)) {
      const quantity = quantities[product?.ItemCode] || 1;

      // Use the selected price breakdown for this product, if available
      const selectedBreakdown = selectedPriceBreakdown[product?.ItemCode] || {};
      // const priceBDownIdToUse = selectedBreakdown.priceBreakDownId || priceBreakDown;

      const product_price_id = product?.ProductPrice?.[0]?.id ? product?.ProductPrice?.[0]?.id : '';

      const url = `${pathObj.baseURL}${pathObj.addCart}`;
      const payload = {
        customer_id: customerId,
        product_id: product?.id,
        quantity: quantity,
        price_break_down_id: priceBreakDownId ? priceBreakDownId : '',
        product_price_id,
        Csprice: selectedBreakdown.price ? selectedBreakdown.price : product?.Csprice > 0 ? product?.Csprice : 0,
        price: selectedBreakdown.price ? selectedBreakdown.price : product?.Csprice > 0 ? 0 : product?.MainProductPrice || currentPrice, 
        product_itemcode: product?.ItemCode,
        customer_cardcode: compData?.CardCode,
        // price: selectedBreakdown.price || product?.MainProductPrice, // Send the selected price
      };
      try {
        const response = await CommonService.getAllWithBodyWithToken(url, payload);
        if (response.success) {
          toast.success(response.message || `${product?.ItemCode} added to cart  successfully.!`);
          addToCartCount(product);
        } else {
          toast.error(response.message || "Something went wrong!");
        }
      } catch (error) {
        console.error("Error adding product to cart:", error);
        errorHandling(error);
      }
    } else {
      toast.error("Item Currently not available!");
    }
  };


  const handleRatingChange = async (itemCode, rating) => {
    if (rating && itemCode) {
      const url = `${pathObj.baseURL}${pathObj.saveRating}`; // Update with your API endpoint
      const payload = {
        product_id: itemCode,
        customer_id: customerId,
        rating: rating,
      };
      try {
        const response = await CommonService.getAllWithBodyWithToken(url, payload);
        if (response.success) {
          toast.success(response?.message || "Rating submitted successfully!");
          setTimeout(() => {
            fetchProductData();
          }, 2000);
        } else {
          toast.error(response.message || "Failed to submit rating.");
        }
      } catch (error) {
        console.error("Error submitting rating:", error);
        errorHandling(error);
      }
    };
  }

  const handleWishlistToggle = async (productItemCode) => {
    const currentStatus = wishlistStatus[productItemCode] || false; // Get current status of the product
    const url = `${pathObj.baseURL}/saveFavoriteItem`; // Update with your API endpoint
    const payload = {
      customer_id: customerId,
      product_id: productItemCode,
      status: currentStatus ? 0 : 1, // Toggle wishlist status
    };

    try {
      const response = await CommonService.getAllWithBodyWithToken(url, payload);
      if (response.success) {
        // Update the wishlist status for the specific product
        setWishlistStatus((prevStatus) => ({
          ...prevStatus,
          [productItemCode]: !currentStatus, // Toggle the wishlist status
        }));
        toast.success(response?.message || "Wishlist updated successfully!");
        setTimeout(() => {
          fetchProductData();
        }, 300);
      } else {
        toast.error(response.message || "Failed to update wishlist.");
      }
    } catch (error) {
      console.error("Error updating wishlist:", error);
      toast.error("An error occurred while updating the wishlist.");
      errorHandling(error);
    }
  };

  const handleProductGroupDetailsClick = (product) => {
    localStorage.setItem('productType', product?.ProductType);
    const formattedItemCode = product?.ItemCode.replace(/\//g, '__'); // Replace slashes with hyphens
    navigate(`/group-products/${formattedItemCode}`);
  }

  const handleClearAll = () => {
    setFilters([]); // Clear the filters
    fetchProductData(1, limit, shortBy); // Call the product data with no filters
  };

  return (
    <>
      <Helmet>
        {/* <title>{childName || "Default Product Name"} | Davenport Burgess</title> */}
        <meta name="description" content="Product page" />
      </Helmet>
      
      <div className="product_listing" style={{ minHeight: '100vh' }}>
        <div className="container">
          <div className="clinner d-flex flex-wrap align-items-start pt-4">
            <div className="product_sidebar">
              <div className="pstitle d-flex flex-wrap align-items-center justify-content-between">
                {attributesList?.length > 0 &&
                  <>
                    <h3>Filters</h3>
                    <a href="#" onClick={handleClearAll}>Clear All</a>
                  </>
                }
              </div>
              <div className="accordion" id="accordionExample">
                {attributesList && attributesList?.map((attribute, index) => (
                  <div className="accordion-item" key={index}>
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#filter-${index}`}
                        aria-expanded="false"
                      >
                        {attribute?.filter_label}
                      </button>
                    </h2>
                    <div
                      id={`filter-${index}`}
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body"
                        style={{
                          maxHeight: attribute?.filter_label_data?.length > 10 ? '200px' : 'auto',
                          overflowY: attribute?.filter_label_data?.length > 10 ? 'auto' : 'visible',
                        }}>
                        {attribute?.filter_label_data?.map((filterOption, idx) => {
                          const isChecked = selectedFilters?.find(
                            filter => filter?.filter_label === attribute?.filter_label && filter?.filter_label_data?.includes(filterOption)
                          );

                          return (
                            <div className="form-check custom_check" key={idx}>
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value={filterOption}
                                id={`filter-option-${index}-${idx}`}
                                onChange={(e) => handleFilterChange(attribute?.filter_label, filterOption, e.target.checked)} // Pass checked status
                                checked={!!isChecked} // Determine if the checkbox is checked
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`filter-option-${index}-${idx}`}
                              >
                                {filterOption}
                              </label>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="prd_block">
              <nav>
                <div class="nav nav-tabs mb-3" id="nav-tab" role="tablist">
                  <button className="nav-link active" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true" onClick={handleResultsTabClick}>Products List</button>
                  <button class="nav-link" id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile" aria-selected="false" onClick={handleCrossRefTabClick}>Cross-References List</button>          
                </div>
              </nav>
              <div class="tab-content p-3 border" id="nav-tabContent">
                <div class="tab-pane fade active show" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                  <div className="prd_toolbar">
                    <h3>Search Results : {text.replace(/__/g, '/')}</h3>
                    <div className="tbSorter">
                      {attributesList?.length > 0 &&
                        <>
                          <div className="toolbar_sorter">
                            <label className="sorter_label">Sort By</label>
                            <select className="form-select" value={shortBy} onChange={handleShortBy}>
                              <option value="default">Most Popular</option>
                              <option value="product_name">Product Name</option>
                              <option value="price_min_to_max">Price: Low to High</option>
                              <option value="price_max_to_min">Price: High to Low</option>
                            </select>

                          </div>
                          <div className="toolbar_sorter">
                            <label className="sorter_label">Show</label>
                            <select className="form-select" value={limit} onChange={handleLimitChange}>
                              <option value="10">10</option>
                              <option value="15">15</option>
                              <option value="20">20</option>
                              <option value="25">25</option>
                              <option value="30">30</option>
                            </select>
                            <div className="perpage">per page</div>
                          </div>
                        </>
                      }
                    </div>
                  </div>
                  {loading ? (
                    <div className="loader"></div>
                  ) : (
                    <>
                      <ProductGrid
                        products={productData}
                        loading={loading}
                        imageStatus={imageStatus}
                        priceBreakDownloading={priceBreakDownloading}
                        onProductClick={handleProductDetailsClick}
                        onGroupClick={handleProductGroupDetailsClick}
                        wishlistStatus={wishlistStatus}
                        handleWishlistToggle={handleWishlistToggle}
                        quantities={quantities}
                        handleQuantityChange={handleQuantityChange}
                        togglePriceDropdown={togglePriceDropdown}
                        priceDropdownVisible={priceDropdownVisible}
                        priceBreak={priceBreak}
                        currencySymbol={currencySymbol}
                        handlePriceBreakdownClick={handlePriceBreakdownClick}
                        token={token}
                        handleRatingChange={handleRatingChange}
                        handleAddToCart={handleAddToCart}
                      />

                      <div className="pagination_box">
                        {(listTotal > limit) && (
                          <Pagination
                            activePage={pageNo}
                            itemsCountPerPage={limit}
                            totalItemsCount={listTotal}
                            pageRangeDisplayed={5}
                            onChange={handlePageChange}
                            itemClass="page-item"
                            linkClass="page-link"
                          />
                        )}
                      </div>
                    </>
                  )}
                </div>
                <div className="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
                  <div className="prd_toolbar">
                    <h3>Search Results : {text.replace(/__/g, '/')}</h3>
                    <div className="tbSorter">
                      {attributesList?.length > 0 &&
                        <>
                          <div className="toolbar_sorter">
                            <label className="sorter_label">Sort By</label>
                            <select className="form-select" value={shortBy} onChange={handleShortBy}>
                              <option value="default">Most Popular</option>
                              <option value="product_name">Product Name</option>
                              <option value="price_min_to_max">Price: Low to High</option>
                              <option value="price_max_to_min">Price: High to Low</option>
                            </select>

                          </div>
                          <div className="toolbar_sorter">
                            <label className="sorter_label">Show</label>
                            <select className="form-select" value={limit} onChange={handleLimitChange}>
                              <option value="10">10</option>
                              <option value="15">15</option>
                              <option value="20">20</option>
                              <option value="25">25</option>
                              <option value="30">30</option>
                            </select>
                            <div className="perpage">per page</div>
                          </div>
                        </>
                      }
                    </div>
                  </div>
                  {crossRefLoading ? (
                    <div className="loader"></div>
                  ) : (
                    <>
                      <ProductGrid
                                  products={crossRefData}
                                  loading={crossRefLoading}
                                  imageStatus={imageStatus}
                          priceBreakDownloading={priceBreakDownloading}
                                  onProductClick={handleProductDetailsClick}
                                  onGroupClick={handleProductGroupDetailsClick}
                                  wishlistStatus={wishlistStatus}
                                  handleWishlistToggle={handleWishlistToggle}
                                  quantities={quantities}
                                  handleQuantityChange={handleQuantityChange}
                                  togglePriceDropdown={togglePriceDropdown}
                                  priceDropdownVisible={priceDropdownVisible}
                                  priceBreak={priceBreak}
                                  currencySymbol={currencySymbol}
                                  handlePriceBreakdownClick={handlePriceBreakdownClick}
                                  token={token}
                                  handleRatingChange={handleRatingChange}
                                  handleAddToCart={handleAddToCart}
                                />
                      <div className="pagination_box">
                        {(crossRefTotal > limit) && (
                          <Pagination
                            activePage={crossRefPage}
                            itemsCountPerPage={limit}
                            totalItemsCount={crossRefTotal}
                            pageRangeDisplayed={5}
                            onChange={handleCrossRefPageChange}
                            itemClass="page-item"
                            linkClass="page-link"
                          />
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
}
export default SearchResult;